/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ResetPasswordSent/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import Info from 'DesignSystem/Info/index'
import OnboardingEmail from 'DesignSystem/Images/OnboardingEmail/index'
import OnboardingMailMask from 'DesignSystem/Svgs/OnboardingMailMask/index'
import React from 'react'
import SubTitle from 'DesignSystem/SubTitle/index'
import TitleLarge from 'DesignSystem/TitleLarge/index'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import useIsMedia from 'Simple/hooks/useIsMedia'
import { animated, useSpring } from "@react-spring/web"



/** @type {import('Simple/types.js').View} */
export default function ResetPasswordSent({
  children,
  viewPath = "/App/Auth/ResetPasswordSent"
  
}) {
  let isBefore = useIsBefore()
  let isMedia = useIsMedia()
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsGreen700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.700'
        })
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let animatedVertical31 = useSpring({
"config": {
friction: 10,
tension: 170,
},
"delay": 350,
"from": {"top": "-120px"},
"to": {"top": isBefore ? "0px" : "-120px"},
})
  return (<React.Fragment
>
<div
  data-testid="ResetPasswordSent.Vertical"
  data-view-path={viewPath}
 style={{'--w-1-Z2g90JK': isBefore ? "50%" : "100%"}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="ResetPasswordSent.Vertical:1"
  data-view-path={viewPath}
 style={{'--bc-2-Z2g90JK': dtColorsWhite,'--bblr-3-Z2g90JK': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bbrr-4-Z2g90JK': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--btlr-5-Z2g90JK': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--btrr-6-Z2g90JK': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-7-Z2g90JK': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-8-Z2g90JK': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-9-Z2g90JK': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--sc-10-Z2g90JK': dtColorsGreen700,'--o-12-Z2g90JK': isBefore ? 0 : 1,'--tx-11-Z2g90JK': isBefore ? "100px" : "0px",'--w-1-Z2g90JK': isMedia.mobile ? "360px" : "500px"}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="ResetPasswordSent.Vertical:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical2}`}
>
<OnboardingMailMask
  viewPath={`${viewPath}/OnboardingMailMask`}
 width={200}
 height="auto"
/>
</div>
<animated.div
  data-testid="ResetPasswordSent.Vertical:3"
  data-view-path={viewPath}
 style={{"--t-13-Z2g90JK": animatedVertical31.top,'--o-12-Z2g90JK': isBefore ? 0 : 1}}
 className={`views-block ${styles.Vertical3}`}
>
<OnboardingEmail
  viewPath={`${viewPath}/OnboardingEmail`}
 width={200}
 height="auto"
/>
</animated.div>
<div
  data-testid="ResetPasswordSent.Vertical:4"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical4}`}
/>
<div
  data-testid="ResetPasswordSent.Vertical:5"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical5}`}
>
<TitleLarge
  viewPath={`${viewPath}/TitleLarge`}
 text="Check your email!"
/>
<SubTitle
  viewPath={`${viewPath}/SubTitle`}
 marginRight={dtSpaceL}
 marginLeft={dtSpaceL}
 textAlign="center"
 marginTop={dtSpaceS}
 lineHeight="20px"
 text="Click on the link in the email to reset your password"
/>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 alignSelf="center"
 type="primary"
 marginTop={isMedia.mobile ? dtSpaceL : "48px"}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../ResetPassword'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../ResetPassword'))}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Send Again"
/>
)}
</TysiaButton>
<Info
  viewPath={`${viewPath}/Info`}
 marginTop={dtSpaceS}
 text="No email? Check your spam folder"
 size="small"
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}